import { assoc } from 'ramda';
import { combineReducers } from 'redux';

import { HIDE_PASSCODE, SHOW_PASSCODE, PASSCODE_PASSED } from './constants';

const visibleFor = (state = false, action) => {
  switch (action.type) {
    case SHOW_PASSCODE: return action.payload;
    case HIDE_PASSCODE: return false;
    default: return state;
  }
};

const byBarberId = (state = {}, action) => {
  switch (action.type) {
    case PASSCODE_PASSED:
      return assoc(action.payload.id, true, state);
    default:
      return state;
  }
};

const byBarberRoute = (state = {}, action) => {
  switch (action.type) {
    case PASSCODE_PASSED:
      return assoc(action.payload.route, true, state);
    default:
      return state;
  }
};

export default combineReducers({ visibleFor, byBarberId, byBarberRoute });



// WEBPACK FOOTER //
// ./src/app/passcode/reducer.js